// TODO: Look into using https://c15t.com/docs/storing-consent/offline-mode instead...

import CookieConsent, { Cookies } from "react-cookie-consent";

export const removeAnalyticCookies = () => {
  // Delete all cookies from google analytics
  // Remove the default tracker.
  const windowObj: Object | any = window;
  if (windowObj.ga) windowObj.ga("remove");
  if (windowObj.gtag) windowObj.gtag = null;
  // Remove the default cookies
  // _ga is used to distinguish users.
  Cookies.remove("_ga", { path: "/" });
  // _gid is used to distinguish users.
  Cookies.remove("_gid", { path: "/" });
  // _gat is used to throttle request rate.
  Cookies.remove("_gat", { path: "/" });
  Cookies.remove("*", { path: "/" });
};

const CookieConsentBanner = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="I accept"
      cookieName="consent-cookie"
      style={{ 
        background: "rgba(255, 255, 255, 0.9)", 
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: "24px 24px 0 0",
        boxShadow: "0 -8px 32px rgba(31, 38, 135, 0.2)",
        color: "#374151",
        fontSize: "16px",
        fontFamily: "SF Pro Display, system-ui, -apple-system, sans-serif",
        fontWeight: "500"
      }}
      buttonStyle={{ 
        background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
        color: "#ffffff", 
        fontSize: "15px",
        fontWeight: "600",
        borderRadius: "16px",
        border: "none",
        padding: "12px 24px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        transition: "all 0.2s ease-in-out"
      }}
      declineButtonStyle={{
        background: "rgba(156, 163, 175, 0.1)",
        color: "#6b7280",
        fontSize: "15px",
        fontWeight: "600",
        borderRadius: "16px",
        border: "1px solid rgba(156, 163, 175, 0.2)",
        padding: "12px 24px",
        marginRight: "12px",
        transition: "all 0.2s ease-in-out"
      }}
      expires={180}
      enableDeclineButton
      onDecline={removeAnalyticCookies}
    >
      This website uses cookies to improve user experience. By using our website
      you consent to all cookies in accordance with our Cookie Policy.
    </CookieConsent>
  );
};

export default CookieConsentBanner;
